import startImg from '@/assets/images/caret-right-fill.svg';
import pauseImg from '@/assets/images/pause-fill.svg';
import { pauseImageTimer, resumeImageTimer } from '@/helpers/mediaUtils';
import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { closeModal } from '@/helpers/closeModal';
import { commonChangeMediaProcess, updateBanners } from '@/helpers/mediaUtils';
import { pauseAllProgressBars, resumeAllProgressBars } from '@/modules/actions/headerLineDuration.js';

const nextMediaCallback = () => {
  window.moviePosition += 1;
  const contents = navigateMediaItem();

  if (!contents) {
    return closeModal();
  }

  commonChangeMediaProcess(contents);
  updateBanners();
};

export const mobileVideoControls = () => {
  const parentElement = document.querySelector('.storeeel-menu-area-icons');

  if (!parentElement) return;

  let imageTime = 0;

  parentElement.addEventListener('click', (event) => {
    if (!event.target) return;

    const modal = document.querySelector('.storeeel-modal');
    const image = modal ? modal.querySelector('.storeeel-media-image') : null;
    const isImageVisible = image && image.style.visibility === 'visible';

    const activeVideo = document.querySelector(
      '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video'
    );

    // =====================
    // 一時停止
    // =====================
    if (event.target.id === 'pause-desktop') {
      imageTime = pauseImageTimer(); // ← 画像でも動画でも止める

      if (activeVideo instanceof HTMLVideoElement) {
        activeVideo.pause();
      }

      pauseAllProgressBars();

      event.target.src = startImg;
      event.target.alt = 'start';
      event.target.id = 'start-desktop';
    }

    // =====================
    // 再開
    // =====================
    else if (event.target.id === 'start-desktop') {
      if (isImageVisible && imageTime > 0) {
        resumeImageTimer(nextMediaCallback, imageTime);
      } else if (activeVideo instanceof HTMLVideoElement) {
        activeVideo.play();
      }

      resumeAllProgressBars();

      event.target.src = pauseImg;
      event.target.alt = 'pause';
      event.target.id = 'pause-desktop';
    }
  });
};

export const controlIcon = () => {
  const controlIcon = document.querySelector('.storeeel-video-control');
  if (controlIcon && controlIcon.id === 'start-desktop') {
    controlIcon.src = pauseImg;
    controlIcon.alt = 'pause';
    controlIcon.id = 'pause-desktop';
  }
};

// activeのスライドの動画のみ再生する関数
export const activeVideoPlay = () => {
  // スライドの動画を一時停止
  const pauseSelectors = [
    '.storeeel-swiper-group-wrapper .swiper-slide-prev .slide-media-wrapper video',
    '.storeeel-swiper-group-wrapper .swiper-slide-next .slide-media-wrapper video'
  ];
  pauseSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(video => {
      if (video instanceof HTMLVideoElement) {
        video.pause();
        video.currentTime = 0;
      }
    });
  });

  // activeのスライドの動画を再生
  const activeVideo = document.querySelector(
    '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video'
  );
  if (activeVideo instanceof HTMLVideoElement) {
    activeVideo.play();
  }
};
